// Mirrors the backend approval + terminal validators (decline, request-revision, expire): trimmed, 5-2000 chars.
export const REASON_MIN_LENGTH = 5;
export const REASON_MAX_LENGTH = 2000;

export function isValidReason(text: string): boolean {
    const length = text.trim().length;
    return length >= REASON_MIN_LENGTH && length <= REASON_MAX_LENGTH;
}
